module.exports = __webpack_public_path__ + "img/howto2-en.0165e6f5.png";